import { createApp } from 'vue';
import App from './App.vue'; // 确保你的 App 组件是使用 .vue 后缀的
import router from './router';
import store from './store/index';
// import api from "./request/api"; // api 接口
import Func from './publicFunction'; // 全局方法
import './assets/css/currency.css'; // 全局样式
import './assets/iconfont.css'; // icon样式
import '@/styles/qw_vip.scss'
// 1. 引入你需要的组件
import {
  Button, Col, Row, Field, Cell, Tab, Tabs, Icon, Form, CellGroup, DatePicker, Picker,
  RadioGroup, Radio, Popup, Toast, NavBar, List, Switch, PasswordInput, NumberKeyboard
} from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';
// 创建 Vue 应用实例
const app = createApp(App);

// 设置全局属性
// app.config.globalProperties.$api = api;
app.config.globalProperties.$Func = Func;

// 使用插件
app.use(router);
app.use(store);

// 3. 注册你需要的组件
app.use(Button).use(Col).use(Row).use(Field).use(Tab).use(Tabs).use(Cell)
  .use(Form)
  .use(CellGroup)
  .use(DatePicker)
  .use(Picker)
  .use(RadioGroup)
  .use(Radio)
  .use(Popup)
  .use(Toast)
  .use(NavBar)
  .use(List)
  .use(Switch)
  .use(PasswordInput)
  .use(NumberKeyboard)
  .use(Icon);

// 挂载应用
app.mount('#app');